// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9B_w8","colBig":"styles_colBig__3NC6U","colSmall":"styles_colSmall__2xOx6"};